var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.referredClients },
          on: { "expand-change": _vm.onExpandChange }
        },
        [
          _c("el-table-column", {
            attrs: { type: "expand" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          padding: "10px",
                          "background-color": "#f3eeee"
                        }
                      },
                      [
                        _c(
                          "el-row",
                          {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: { gutter: 10, type: "flex" }
                          },
                          [
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("div", { staticClass: "info-label" }, [
                                  _c("i", { staticClass: "el-icon-s-home" }),
                                  _vm._v(" Property Type\n                ")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "info-content" },
                                  [
                                    scope.row.townhouse
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticStyle: {
                                              "margin-right": "5px",
                                              "margin-bottom": "5px"
                                            },
                                            attrs: {
                                              size: "small",
                                              type: "success"
                                            }
                                          },
                                          [_vm._v("Townhouse")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.apartment
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticStyle: {
                                              "margin-right": "5px",
                                              "margin-bottom": "5px"
                                            },
                                            attrs: {
                                              size: "small",
                                              type: "success"
                                            }
                                          },
                                          [_vm._v("Apartment")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.houseAndLand
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticStyle: {
                                              "margin-right": "5px",
                                              "margin-bottom": "5px"
                                            },
                                            attrs: {
                                              size: "small",
                                              type: "success"
                                            }
                                          },
                                          [_vm._v("House and Land")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.brandNewAndCompleted
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticStyle: {
                                              "margin-right": "5px",
                                              "margin-bottom": "5px"
                                            },
                                            attrs: {
                                              size: "small",
                                              type: "success"
                                            }
                                          },
                                          [_vm._v("Brand New & Completed")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !scope.row.townhouse &&
                                    !scope.row.apartment &&
                                    !scope.row.houseAndLand &&
                                    !scope.row.brandNewAndCompleted
                                      ? _c(
                                          "span",
                                          { staticClass: "empty-text" },
                                          [_vm._v("N/A")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 16 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("div", { staticClass: "info-label" }, [
                                  _vm._v("Comment")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info-content" }, [
                                  scope.row.notes
                                    ? _c("span", [
                                        _vm._v(_vm._s(scope.row.notes))
                                      ])
                                    : _c(
                                        "span",
                                        { staticClass: "empty-text" },
                                        [_vm._v("N/A")]
                                      )
                                ])
                              ])
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: { gutter: 10, type: "flex" }
                          },
                          [
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("div", { staticClass: "info-label" }, [
                                  _c("i", { staticClass: "el-icon-document" }),
                                  _vm._v(" Settlement Terms\n                ")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "info-content" },
                                  [
                                    scope.row.shortTermSettlement
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticStyle: {
                                              "margin-right": "5px",
                                              "margin-bottom": "5px"
                                            },
                                            attrs: {
                                              size: "small",
                                              type: "success"
                                            }
                                          },
                                          [_vm._v("Short Term Settlement")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.longTermSettlement
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticStyle: {
                                              "margin-right": "5px",
                                              "margin-bottom": "5px"
                                            },
                                            attrs: {
                                              size: "small",
                                              type: "success"
                                            }
                                          },
                                          [_vm._v("Long Term Settlement")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !scope.row.shortTermSettlement &&
                                    !scope.row.longTermSettlement
                                      ? _c(
                                          "span",
                                          { staticClass: "empty-text" },
                                          [_vm._v("N/A")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 4 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("div", { staticClass: "info-label" }, [
                                  _vm._v("Land Size")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info-content" }, [
                                  scope.row.landSize
                                    ? _c("span", { staticClass: "text-i" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.row.landSize + " m²") +
                                            " "
                                        )
                                      ])
                                    : _c(
                                        "span",
                                        { staticClass: "empty-text" },
                                        [_vm._v(" " + _vm._s("N/A") + " ")]
                                      )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 4 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("div", { staticClass: "info-label" }, [
                                  _vm._v("Bedrooms")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "info-content" },
                                  [
                                    scope.row.bedrooms > 0
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "large",
                                              type: "success"
                                            }
                                          },
                                          [_vm._v(_vm._s(scope.row.bedrooms))]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "empty-text" },
                                          [_vm._v("N/A")]
                                        )
                                  ],
                                  1
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 4 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("div", { staticClass: "info-label" }, [
                                  _vm._v("Bathrooms")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "info-content" },
                                  [
                                    scope.row.bathrooms > 0
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "large",
                                              type: "success"
                                            }
                                          },
                                          [_vm._v(_vm._s(scope.row.bathrooms))]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "empty-text" },
                                          [_vm._v("N/A")]
                                        )
                                  ],
                                  1
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 4 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("div", { staticClass: "info-label" }, [
                                  _vm._v("Cars")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "info-content" },
                                  [
                                    scope.row.garage > 0
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "large",
                                              type: "success"
                                            }
                                          },
                                          [_vm._v(_vm._s(scope.row.garage))]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "empty-text" },
                                          [_vm._v("N/A")]
                                        )
                                  ],
                                  1
                                )
                              ])
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 10, type: "flex" } },
                          [
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c(
                                "div",
                                { staticClass: "info-item" },
                                [
                                  _c("div", { staticClass: "info-label" }, [
                                    _c("i", {
                                      staticClass: "el-icon-notebook-2"
                                    }),
                                    _vm._v(" Agent Notes\n                ")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-form",
                                    {
                                      staticStyle: {
                                        "font-family": "DINosaur-a, sans-serif"
                                      },
                                      attrs: {
                                        "label-position": "top",
                                        "label-width": "100px"
                                      },
                                      nativeOn: {
                                        submit: function($event) {
                                          $event.preventDefault()
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-row",
                                        { attrs: { gutter: 10 } },
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 24 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: { label: "Agent Note" }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      type: "textarea",
                                                      rows: "3",
                                                      placeholder:
                                                        "Agent notes",
                                                      maxlength: "100",
                                                      "show-word-limit": ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.agentNotes[
                                                          scope.row.contactId
                                                        ],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.agentNotes,
                                                          scope.row.contactId,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "agentNotes[scope.row.contactId]"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 24 } },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  staticClass: "add-note-btn",
                                                  attrs: {
                                                    icon: "el-icon-plus"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.addNote(
                                                        scope.row.contactId
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Add Note")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 16 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("div", { staticClass: "info-label" }, [
                                  _vm._v("Agent Note History")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "info-content",
                                    staticStyle: {
                                      display: "block",
                                      width: "100%"
                                    }
                                  },
                                  [
                                    Array.isArray(
                                      _vm.agentNotesHistory[scope.row.contactId]
                                    ) &&
                                    _vm.agentNotesHistory[scope.row.contactId]
                                      .length > 0
                                      ? _c(
                                          "el-table",
                                          {
                                            staticClass: "compact-table",
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              data:
                                                _vm.agentNotesHistory[
                                                  scope.row.contactId
                                                ],
                                              height: "200",
                                              "row-style": _vm.rowStyle
                                            }
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "created",
                                                label: "Date",
                                                width: "180"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Channel Partner",
                                                width: "180"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(innerScope) {
                                                      return [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              innerScope.row
                                                                .cpFirstName +
                                                                " " +
                                                                innerScope.row
                                                                  .cpLastName
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "note",
                                                label: "Note"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              padding: "10px",
                                              "text-align": "center"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "empty-text" },
                                              [_vm._v("No notes available")]
                                            )
                                          ]
                                        )
                                  ],
                                  1
                                )
                              ])
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "cpFirstName",
              "min-width": "150",
              label: "Channel Partner"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.cpFirstName + " " + scope.row.cpLastName
                        )
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "desiredSuburbs",
              "min-width": "150",
              label: "Desired Suburbs"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "totalBudget",
              "min-width": "150",
              label: "Client Budget"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.formatCurrency(scope.row.totalBudget)))
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "created", "min-width": "200", label: "Date" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.created))])]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.totalReferredClients
        ? _c(
            "div",
            { staticClass: "fen" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pageReferredClients,
                  "page-size": 25,
                  layout: "total, prev, pager, next",
                  total: _vm.totalReferredClients
                },
                on: { "current-change": _vm.handleCurrentChange }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3695442e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3695442e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enquiry/propertyRequestsTable.vue
// module id = null
// module chunks = 